import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { mainurl } from '../../../Mainurl';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../../style/color';
import { 
    Row, Col, Card, CardHeader, CardBody, Button, Form, Label, Input, 
    CardFooter, Modal, ModalBody, ModalHeader, Badge, Alert, Spinner,
    InputGroup, InputGroupText, Progress
} from 'reactstrap';
import { 
    FaEye, FaPlus, FaUsers, FaSeedling, FaCalendarAlt, 
    FaMapMarkerAlt, FaRuler, FaArrowLeft, FaSearch,
    FaCheckCircle, FaTimesCircle, FaInfoCircle
} from 'react-icons/fa';

const AddPlanning = ({ back, ...props }) => {
    const [loading, setLoading] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [cropTypeOpt, setCropTypeOpt] = useState('');
    const [cropType, setCropType] = useState('');
    const [cropOpt, setCropOpt] = useState('');
    const [crop, setCrop] = useState('');
    const [cropVarietyOpt, setCropVarietyOpt] = useState('');
    const [cropVariety, setCropVariety] = useState('');
    const [planningDate, setPlanningDate] = useState('');
    const [area, setArea] = useState('');
    const [areaUom, setAreaUom] = useState('');
    
    const [state, setState] = useState('');
    const [district, setDistrict] = useState('');
    const [block, setBlock] = useState('');
    
    const [stateOpt, setStateOpt] = useState('');
    const [districtOpt, setDistrictOpt] = useState('');
    const [blockOpt, setBlockOpt] = useState('');
    
    const [farmerList, setFarmerList] = useState('');
    const [selectedRows, setSelectedRows] = useState('');
    const [selectedFarmerList, setSelectedFarmerList] = useState([]);
    
    // Enhanced state for better UX
    const [formErrors, setFormErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [searchLoading, setSearchLoading] = useState(false);

    useEffect(() => {
        get_crop_type();
        get_state_list();
    }, []);

    // Enhanced table styles
    const enhancedTableStyles = {
        ...custTableStyles,
        headCells: {
            style: {
                backgroundColor: 'var(--bs-primary)',
                fontWeight: 'bold',
                fontSize: '14px',
                color: 'white',
                borderBottom: '2px solid var(--bs-primary)',
                paddingTop: '12px',
                paddingBottom: '12px',
            },
        },
        cells: {
            style: {
                paddingTop: '12px',
                paddingBottom: '12px',
                fontSize: '13px',
                borderBottom: '1px solid var(--bs-primary-border-subtle)',
            },
        },
        rows: {
            style: {
                '&:hover': {
                    backgroundColor: 'var(--bs-primary-bg-subtle)',
                    cursor: 'pointer',
                },
            },
        },
    };

    // Validation function
    const validateForm = () => {
        const errors = {};
        if (!cropType || cropType === '0') errors.cropType = 'Please select a crop type';
        if (!crop || crop === '0') errors.crop = 'Please select a crop';
        if (!cropVariety || cropVariety === '0') errors.cropVariety = 'Please select a crop variety';
        if (!planningDate) errors.planningDate = 'Please select a planning date';
        if (!area) errors.area = 'Please enter area';
        if (!areaUom || areaUom === '0') errors.areaUom = 'Please select area unit';
        if (selectedFarmerList.length === 0) errors.farmers = 'Please add at least one farmer';
        
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const get_crop_type = () => {
        let postData = [{"org_id": sessionStorage.getItem('org_id'), "user_id": "10001", "lang_id": 1}];
        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_type_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.crop_type_id}> {row.crop_type_name}</option>
                    )
                });
                setCropTypeOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_crop_list = (e) => {
        setCropOpt('');
        setCrop("0");
        setCropType(e.target.value);
        if (formErrors.cropType) {
            setFormErrors(prev => ({ ...prev, cropType: '' }));
        }
        
        let postData = [{"org_id": sessionStorage.getItem('org_id'), "user_id": "101", "crop_type_id": e.target.value, "lang_id": 1}];

        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_master_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.crop_code}> {row.crop_name}</option>
                    )
                });
                setCropOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const crop_variety_list = (e) => {
        setCrop(e.target.value);
        if (formErrors.crop) {
            setFormErrors(prev => ({ ...prev, crop: '' }));
        }
        
        let postData = [{"org_id": sessionStorage.getItem('org_id'), "user_id": "101", "crop_code": e.target.value, "lang_id": 1}]
        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_variety_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.crop_variety_code}> {row.crop_variety_name}</option>
                    )
                });
                setCropVarietyOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_state_list = (e) => {
        let postData = [{"country_code": "1"}]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.state_code}> {row.state_name}</option>
                    )
                });
                setStateOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_dist_list = (e) => {
        setState(e.target.value);
        setDistrictOpt('');
        setBlockOpt('');
        
        let postData = [{"state_code": e.target.value}]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_dist_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.district_code}> {row.district_name}</option>
                    )
                });
                setDistrictOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_block_list = (e) => {
        setDistrict(e.target.value);
        setBlockOpt('');
        
        let postData = [{"dist_code": e.target.value}]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_block_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.block_code}> {row.block_name}</option>
                    )
                });
                setBlockOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_farmer_list = (e) => {
        setSearchLoading(true);
        setFarmerList('');
        e.preventDefault();
        
        let postData = [{"org_id": sessionStorage.getItem('org_id'), "user_id": "101", "dist_id": 0, "block_id": 0, "vill_id":0}];
        axios({
            method: 'post',
            url: mainurl + 'Farmer/box_farmer_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        {
                            f_code: row.farmer_code,
                            name: row.f_name +" ("+ row.f_name_ne +")",
                            mobile: row.mobile_no,
                            spouse_name: row.f_spouse_name,
                            location: row.state_name +"/"+ row.district_name +"/"+ row.block_name +"/"+ row.village_name,
                        }
                    )
                });

            setFarmerList(list);
            setSearchLoading(false);
        })
        .catch(error => {
            setSearchLoading(false);
        });
    }

    const add_selected_farmer = () => {
        let temp = [...selectedFarmerList];
        selectedRows.forEach(row => {
            let found = selectedFarmerList.find(el => el.f_code === row.f_code);
            if (!found) temp.push(row);
        });
        
        setSelectedFarmerList(temp);
        setViewModal(false);
        if (formErrors.farmers) {
            setFormErrors(prev => ({ ...prev, farmers: '' }));
        }
        setSuccessMessage(`${selectedRows.length} farmer(s) added successfully!`);
        setTimeout(() => setSuccessMessage(''), 3000);
    }

    const removeFarmer = (farmerCode) => {
        setSelectedFarmerList(prev => prev.filter(farmer => farmer.f_code !== farmerCode));
    }

    const handleRowSelected = React.useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const add_planning = () => {
        if (!validateForm()) {
            return;
        }

        setSubmitLoading(true);
        let farmer_list = [];
        selectedFarmerList.forEach(row => {
            farmer_list.push({"f_id": row.f_code}) 
        });

        let postData = [{
            "org_id": sessionStorage.getItem('org_id'),
            "user_id": 10001,
            "crop_type_code": cropType,
            "crop_code": crop,
            "crop_variety": cropVariety,
            "planning_date": planningDate,
            "area": area,
            "area_uom": areaUom,
            "total_farmer": farmer_list.length,
            "farmer_list": farmer_list
        }];

        axios({
            method: 'post',
            url: mainurl + 'Activity/add_planning',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                setSuccessMessage('Planning added successfully!');
                setTimeout(() => {
                    back();
                }, 1500);
                setSubmitLoading(false);
        })
        .catch(error => {
            setSubmitLoading(false);
        });
    }

    // Enhanced columns for selected farmers table
    const selectedFarmersColumns = [
        {
            name: 'Code',
            selector: row => row.f_code,
            sortable: false,
            width: '100px',
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: false,
            width: "25%"
        },
        {
            name: 'Mobile',
            selector: row => row.mobile,
            sortable: false,
            width: '150px',
        },
        {
            name: 'Spouse Name',
            selector: row => row.spouse_name,
            sortable: false,
            width: '180px',
        },
        {
            name: 'Location',
            selector: row => row.location,
            sortable: false,
            width: "25%"
        },
        {
            name: 'Action',
            cell: row => (
                <Button
                    color="danger"
                    size="sm"
                    outline
                    onClick={() => removeFarmer(row.f_code)}
                >
                    <FaTimesCircle />
                </Button>
            ),
            width: '80px',
            ignoreRowClick: true,
        },
    ];

    const modalFarmersColumns = [
        {
            name: 'Code',
            selector: row => row.f_code,
            sortable: false,
            width: '100px',
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: false,
            width: "30%"
        },
        {
            name: 'Spouse Name',
            selector: row => row.spouse_name,
            sortable: false,
            width: '200px',
        },
        {
            name: 'Location',
            selector: row => row.location,
            sortable: false,
            width: "40%"
        },
    ];

    return (
        <>
            {/* Success Alert */}
            {successMessage && (
                <Alert color="success" className="d-flex align-items-center mb-3">
                    <FaCheckCircle className="me-2" />
                    {successMessage}
                </Alert>
            )}

            {/* Main Form Card */}
            <Card className='mb-4 shadow-sm border-0'>
                <CardHeader className='bg-primary text-white d-flex justify-content-between align-items-center'>
                    <div className="d-flex align-items-center">
                        <FaSeedling className="me-2" />
                        <h5 className="mb-0">Create New Farming Plan</h5>
                    </div>
                    <Button 
                        color="light" 
                        size="sm" 
                        onClick={back}
                        className="d-flex align-items-center"
                    > 
                        <FaArrowLeft className="me-1" /> Back 
                    </Button>
                </CardHeader>
                <CardBody className="p-4">
                    <Row>
                        <Col lg={3} md={6} className="mb-3">
                            <Label for="type" className="fw-bold text-primary">
                                <FaSeedling className="me-1" />
                                Crop Type <span className="text-danger">*</span>
                            </Label>
                            <Input 
                                id="type" 
                                bsSize="sm" 
                                type="select" 
                                value={cropType} 
                                onChange={get_crop_list}
                                invalid={!!formErrors.cropType}
                                className="form-select border-primary"
                            >
                                <option value="0">-- Select Crop Type --</option>
                                {cropTypeOpt}
                            </Input>
                            {formErrors.cropType && (
                                <small className="text-danger">{formErrors.cropType}</small>
                            )}
                        </Col>

                        <Col lg={3} md={6} className="mb-3">
                            <Label for="crop" className="fw-bold text-primary">
                                <FaSeedling className="me-1" />
                                Crop <span className="text-danger">*</span>
                            </Label>
                            <Input 
                                id="crop" 
                                bsSize="sm" 
                                type="select" 
                                value={crop} 
                                onChange={crop_variety_list}
                                invalid={!!formErrors.crop}
                                disabled={!cropType || cropType === '0'}
                                className="border-primary"
                            >
                                <option value="0">-- Select Crop --</option>
                                {cropOpt}
                            </Input>
                            {formErrors.crop && (
                                <small className="text-danger">{formErrors.crop}</small>
                            )}
                        </Col>

                        <Col lg={3} md={6} className="mb-3">
                            <Label for="cropVariety" className="fw-bold text-primary">
                                <FaSeedling className="me-1" />
                                Variety <span className="text-danger">*</span>
                            </Label>
                            <Input 
                                id="cropVariety" 
                                bsSize="sm" 
                                type="select" 
                                value={cropVariety} 
                                onChange={(e) => {
                                    setCropVariety(e.target.value);
                                    if (formErrors.cropVariety) {
                                        setFormErrors(prev => ({ ...prev, cropVariety: '' }));
                                    }
                                }}
                                invalid={!!formErrors.cropVariety}
                                disabled={!crop || crop === '0'}
                                className="border-primary"
                            >
                                <option value="0">-- Select Variety --</option>
                                {cropVarietyOpt}
                            </Input>
                            {formErrors.cropVariety && (
                                <small className="text-danger">{formErrors.cropVariety}</small>
                            )}
                        </Col>

                        <Col lg={3} md={6} className="mb-3">
                            <Label for="planning_date" className="fw-bold text-primary">
                                <FaCalendarAlt className="me-1" />
                                Planning Date <span className="text-danger">*</span>
                            </Label>
                            <Input 
                                type="date" 
                                id="planning_date" 
                                bsSize="sm" 
                                value={planningDate} 
                                onChange={(e) => {
                                    setPlanningDate(e.target.value);
                                    if (formErrors.planningDate) {
                                        setFormErrors(prev => ({ ...prev, planningDate: '' }));
                                    }
                                }}
                                invalid={!!formErrors.planningDate}
                                className="border-primary"
                            />
                            {formErrors.planningDate && (
                                <small className="text-danger">{formErrors.planningDate}</small>
                            )}
                        </Col>

                        <Col lg={4} md={6} className="mb-3">
                            <Label for="area" className="fw-bold text-primary">
                                <FaRuler className="me-1" />
                                Area <span className="text-danger">*</span>
                            </Label>
                            <Input 
                                type="number" 
                                id="area" 
                                bsSize="sm" 
                                value={area} 
                                onChange={(e) => {
                                    setArea(e.target.value);
                                    if (formErrors.area) {
                                        setFormErrors(prev => ({ ...prev, area: '' }));
                                    }
                                }}
                                placeholder="Enter area"
                                invalid={!!formErrors.area}
                                className="border-primary"
                            />
                            {formErrors.area && (
                                <small className="text-danger">{formErrors.area}</small>
                            )}
                        </Col>

                        <Col lg={4} md={6} className="mb-3">
                            <Label for="uom" className="fw-bold text-primary">
                                <FaRuler className="me-1" />
                                Unit <span className="text-danger">*</span>
                            </Label>
                            <Input 
                                id="uom" 
                                bsSize="sm" 
                                type="select" 
                                value={areaUom} 
                                onChange={(e) => {
                                    setAreaUom(e.target.value);
                                    if (formErrors.areaUom) {
                                        setFormErrors(prev => ({ ...prev, areaUom: '' }));
                                    }
                                }}
                                invalid={!!formErrors.areaUom}
                                className="border-primary"
                            >
                                <option value="0">-- Select Unit --</option>
                                <option value="101">Decimal</option>
                                <option value="102">Acre</option>
                                <option value="103">Hectare</option>
                                <option value="104">Square feet</option>
                            </Input>
                            {formErrors.areaUom && (
                                <small className="text-danger">{formErrors.areaUom}</small>
                            )}
                        </Col>

                        <Col lg={4} md={6} className="mb-3 d-flex align-items-end">
                            <Button 
                                color="primary" 
                                size="sm" 
                                onClick={() => setViewModal(true)} 
                                block
                                className="d-flex align-items-center justify-content-center"
                            > 
                                <FaPlus className="me-2" />
                                Add Farmers
                            </Button>
                        </Col>
                    </Row>

                    {formErrors.farmers && (
                        <Alert color="warning" className="mt-2">
                            <FaInfoCircle className="me-2" />
                            {formErrors.farmers}
                        </Alert>
                    )}
                </CardBody>
            </Card>

            {/* Selected Farmers Card */}
            <Card className="shadow-sm border-primary">
                <CardHeader className="bg-primary bg-opacity-10 d-flex justify-content-between align-items-center border-bottom border-primary">
                    <div className="d-flex align-items-center">
                        <FaUsers className="me-2 text-primary" />
                        <h6 className="mb-0 text-primary">Selected Farmers</h6>
                        <Badge color="primary" className="ms-2">
                            {selectedFarmerList.length}
                        </Badge>
                    </div>
                </CardHeader>
                <CardBody className="p-0">
                    <DataTable
                        customStyles={enhancedTableStyles}
                        columns={selectedFarmersColumns}
                        data={selectedFarmerList}
                        highlightOnHover
                        progressPending={loading}
                        noDataComponent={
                            <div className="text-center p-4">
                                <FaUsers className="text-primary mb-2" size={48} />
                                <p className="text-primary">No farmers selected yet</p>
                            </div>
                        }
                    />
                </CardBody>
                <CardFooter className="bg-primary bg-opacity-10 text-end border-top border-primary">
                    <Button 
                        color="primary" 
                        size="sm" 
                        onClick={add_planning}
                        disabled={submitLoading}
                        className="px-4"
                    > 
                        {submitLoading ? (
                            <>
                                <Spinner size="sm" className="me-2" />
                                Creating Plan...
                            </>
                        ) : (
                            <>
                                <FaCheckCircle className="me-2" />
                                Create Plan
                            </>
                        )}
                    </Button>
                </CardFooter>
            </Card>

            {/* Farmer Selection Modal */}
            <Modal
                centered
                scrollable
                size="xl"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
                className="modal-custom"
            >
                <ModalHeader 
                    toggle={() => setViewModal(!viewModal)}
                    className="bg-primary text-white"
                >
                    <FaSearch className="me-2" />
                    Select Farmers
                </ModalHeader>
                <ModalBody className="p-4">
                    {/* Search Form */}
                    <Card className="mb-4 border-primary">
                        <CardBody className="bg-primary bg-opacity-10">
                            <Form onSubmit={get_farmer_list}>
                                <Row>
                                    <Col md={3} className="mb-3">
                                        <Label for="state" className="fw-bold text-primary">
                                            <FaMapMarkerAlt className="me-1" />
                                            State
                                        </Label>
                                        <Input 
                                            id="state" 
                                            bsSize="sm" 
                                            type="select" 
                                            value={state} 
                                            onChange={get_dist_list}
                                            className="border-primary"
                                        >
                                            <option value="0">-- Select State --</option>
                                            {stateOpt}
                                        </Input>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <Label for="district" className="fw-bold text-primary">
                                            <FaMapMarkerAlt className="me-1" />
                                            District
                                        </Label>
                                        <Input 
                                            id="district" 
                                            bsSize="sm" 
                                            type="select" 
                                            value={district} 
                                            onChange={get_block_list}
                                            disabled={!state || state === '0'}
                                            className="border-primary"
                                        >
                                            <option value="0">-- Select District --</option>
                                            {districtOpt}
                                        </Input>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <Label for="block" className="fw-bold text-primary">
                                            <FaMapMarkerAlt className="me-1" />
                                            Block
                                        </Label>
                                        <Input 
                                            id="block" 
                                            bsSize="sm" 
                                            type="select" 
                                            value={block} 
                                            onChange={(e) => setBlock(e.target.value)}
                                            disabled={!district || district === '0'}
                                            className="border-primary"
                                        >
                                            <option value="0">-- Select Block --</option>
                                            {blockOpt}
                                        </Input>
                                    </Col>
                                    <Col md={3} className="mb-3 d-flex align-items-end">
                                        <Button 
                                            color="primary" 
                                            size="sm" 
                                            block
                                            disabled={searchLoading}
                                        > 
                                            {searchLoading ? (
                                                <>
                                                    <Spinner size="sm" className="me-2" />
                                                    Searching...
                                                </>
                                            ) : (
                                                <>
                                                    <FaSearch className="me-2" />
                                                    Search Farmers
                                                </>
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>

                    {/* Farmers Table */}
                    <Row>
                        <Col xs={12}>
                            <DataTable
                                title="Available Farmers"
                                customStyles={enhancedTableStyles}
                                columns={modalFarmersColumns}
                                data={farmerList}
                                highlightOnHover
                                selectableRows
                                onSelectedRowsChange={handleRowSelected}
                                progressPending={searchLoading}
                                noDataComponent={
                                    <div className="text-center p-4">
                                        <FaUsers className="text-primary mb-2" size={48} />
                                        <p className="text-primary">
                                            {searchLoading ? 'Searching farmers...' : 'Click "Search Farmers" to load data'}
                                        </p>
                                    </div>
                                }
                            />
                        </Col>
                        {selectedRows && selectedRows.length > 0 && (
                            <Col xs={12} className="text-end mt-3">
                                <Badge color="primary" className="me-2">
                                    {selectedRows.length} farmer(s) selected
                                </Badge>
                                <Button 
                                    color="primary" 
                                    size="sm" 
                                    onClick={add_selected_farmer}
                                    className="px-4"
                                > 
                                    <FaPlus className="me-2" />
                                    Add Selected Farmers
                                </Button>
                            </Col>
                        )}
                    </Row>
                </ModalBody>
            </Modal>
        </>
    )
}

export default AddPlanning;